<div class="wo-app-login-container">
  <img [src]="'wo-common/assets/swc-logo_180x166.webp' | woFileHash" alt="ISS" class="wo-app-login-logo"/>
  <div class="wo-app-login-title wo-app-login__title">
    {{ appName }}
  </div>
  <iss-form-field class="wo-app-login-field">
    <iss-label>Email</iss-label>
    <tui-input
      [formControl]="control"
      [tuiTextfieldLabelOutside]="true"
      [tuiTextfieldCleaner]="true"
      (keydown.enter)="onContinue()"
    >
      Email
      <input tuiTextfield type="email" autocomplete id="email" />
    </tui-input>
  </iss-form-field>
  <div class="wo-app-login-field">
    <button
      tuiButton
      class="wo-app-login__continue"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
  <div class="wo-app-login-note">
    If you have forgotten your password or have trouble logging in, please contact the support center
  </div>
</div>
